export const FormTypeConstants = {
  HO3: 'HO3',
  HO4: 'HO4',
  HO6: 'HO6',
  DP3: 'DP3'
};
